// extracted by mini-css-extract-plugin
module.exports = {"close":"dialog-edit_close__C1XBG"};